import { useAppDispatch, useAppSelector } from "../../../hooks";
import { WebAppApplicationTypes } from "../../../types/web-app";
import {
  handleChangeWebAppApplicationType,
  handleClearWebAppCreationSlice,
  selectWebAppSelectedApplicationType,
} from "../../../store/web-app/webAppCreateSlice";
import { useCallback } from "react";
import { Tag, Typography } from "djuno-design";
import { DeployTypeCard } from "./DeployingTypeStep";

export interface WebAppApplicationTypeOptions {
  name: WebAppApplicationTypes;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  disabled?: boolean;
}

const deployTypes: WebAppApplicationTypeOptions[] = [
  {
    name: "web-app",
    title: <div>Web App</div>,
    description:
      "Dynamic web app. Ideal for full-stack apps, API services, and mobile backends.",
  },
  {
    name: "backgroud-worker",
    title: (
      <div className="flex items-center gap-1">
        Background Workers <Tag color="processing">Comming soon</Tag>
      </div>
    ),
    description:
      "Long-lived services that process async tasks, usually from a job queue.",
    disabled: true,
  },
  {
    name: "private-service",
    title: (
      <div className="flex items-center gap-1">
        Private Services <Tag color="processing">Comming soon</Tag>
      </div>
    ),
    description:
      "Web app hosted on a private network, accessible only from your other Render services.",
    disabled: true,
  },
];

const ApplicationTypeStep = () => {
  const selectedApplicationType = useAppSelector(
    selectWebAppSelectedApplicationType
  );

  const dispatch = useAppDispatch();

  const handleChangeDeployType = useCallback(
    (deployType: string) => {
      dispatch(
        handleClearWebAppCreationSlice({ withoutApplicationType: true })
      );
      dispatch(
        handleChangeWebAppApplicationType(deployType as WebAppApplicationTypes)
      );
    },
    [dispatch]
  );

  return (
    <div className="max-w-3xl mx-auto pb-12 flex flex-col">
      <Typography.Text size="sm" className="font-medium">
        How would you like to deploy your web service?
      </Typography.Text>
      <div className="mt-4 w-full flex flex-col gap-4">
        {deployTypes.map((deployType, index) => (
          <DeployTypeCard
            key={index}
            {...deployType}
            selected={selectedApplicationType === deployType.name}
            onClick={handleChangeDeployType}
          />
        ))}
      </div>
    </div>
  );
};

export default ApplicationTypeStep;
